<template>
  <v-container fluid>
    <div class="headline-container">
      <v-row justify="space-between">
        <v-col cols="12" md="6">
          <span class="headline">Agenda</span>
        </v-col>
      </v-row>
    </div>
    <v-card class="agenda-container">
      <v-layout>
        <v-row>
          <v-col cols="12" md="6">
            <v-tabs v-if="isSekpri" v-model="tab">
              <v-tab>Agenda Pribadi</v-tab>
              <v-tab>Agenda Pimpinan</v-tab>
            </v-tabs>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" md="4">
            <v-row v-if="tab === 1" class="mr-2">
              <v-col cols="6">
                <v-btn
                  width="100%"
                  rounded
                  color="default"
                  @click="$refs.report.show()"
                >
                  <v-icon left color="primary" class="hidden-sm-and-down">
                    mdi-printer
                  </v-icon>
                  CETAK
                </v-btn>
              </v-col>
              <v-col cols="6">
                <v-btn
                  width="100%"
                  color="primary"
                  rounded
                  @click="$refs.form.showForm()"
                >
                  <v-icon left>
                    mdi-plus
                  </v-icon>
                  Input Agenda
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-layout>
      <Calendar
        ref="calendar"
        :pimpinan="Boolean(tab)"
        @edit="agenda => $refs.form.editAgenda(agenda)"
      />
    </v-card>
    <agenda-form ref="form" @submited="loadAgenda" />
    <Laporan ref="report" />
  </v-container>
</template>

<script>
import AgendaForm from '@/components/Agenda/AgendaForm'
import Calendar from '@/components/Agenda/Calendar'
import Laporan from '@/components/Agenda/Laporan'
import { mapGetters } from 'vuex'

export default {
  components: {
    'agenda-form': AgendaForm,
    Calendar,
    Laporan
  },
  data() {
    return {
      tab: 0
    }
  },
  computed: {
    ...mapGetters(['roles']),
    isSekpri() {
      return this.roles.includes('Sekpri')
    }
  },
  mounted() {
    this.loadAgenda()
  },
  methods: {
    loadAgenda() {
      this.$refs.calendar.load(true)
    }
  }
}
</script>

<style scoped>
.agenda-container {
  padding-bottom: 0.5rem;
}
</style>
